import React, { useState } from 'react';
import List from './List';
import { ItemStyle, ListStyle, DataProps, RenderItem } from './interface';
interface IProps extends ItemStyle,ListStyle,DataProps, RenderItem{
}
export default function Container(props: IProps) {
  

    const [dataList, setList] = useState<any[]>(props.dataList);

    const changeCardList = (list: any[]) => {
        setList([...list]);
    };
    
    React.useEffect(() => {
        setList(props.dataList);
    }, [props.dataList]);

    return (
        <List
            {...props}
            dataList={ dataList }
            changeCardList={ changeCardList }
        />
    );
}




// WEBPACK FOOTER //
// ./src/display/components/Drop/Container.tsx